import React, { Component } from 'react';
import NavPills from 'components/NavPills/NavPills';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import PreviewIos from 'components/NotificationsPreview/PreviewIos';
import PreviewAndroid from 'components/NotificationsPreview/PreviewAndroid';

import withStyles from '@material-ui/core/styles/withStyles';

import styles from 'assets/jss/material-dashboard-pro-react/components/notificationsPreviewStyles';

class NotificationsPreview extends Component {

	render() {
		const { classes, ...props } = this.props;
		return (
			<GridContainer className={classes.previewContainer}>
				<GridItem xs={12} sm={12} md={12}>
					<NavPills
						color="warning"
						className={classes.previewButtons}
						customClasses={classes}
						alignCenter
						tabs={[
							{
								classes: classes,
								tabButton: "IOS",
								tabContent: (
									<PreviewIos {...props} />
								)
							},
							{
								classes: classes,
								tabButton: "ANDROID",
								tabContent: (
									<PreviewAndroid {...props} />
								)
							}
						]}
					/>
				</GridItem>
			</GridContainer>
		)
	}
}

export default withStyles(styles)(NotificationsPreview);